import React from "react";
import { useLocation } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";

// WhatsApp brand SVG (keeps in line with the logo style, doesn't rely on emoji)
const WhatsAppIcon = ({ size = 28 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    width={size}
    height={size}
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M19.11 17.21c-.31-.16-1.84-.91-2.13-1.01-.29-.11-.5-.16-.71.16-.21.32-.81 1.01-.99 1.22-.18.21-.36.24-.67.08-.31-.16-1.31-.48-2.49-1.54-.92-.82-1.54-1.83-1.72-2.14-.18-.31-.02-.48.13-.63.13-.13.31-.34.47-.51.16-.17.21-.29.31-.49.11-.21.05-.39-.03-.55-.08-.16-.71-1.7-.97-2.34-.26-.61-.52-.53-.71-.54-.18-.01-.39-.01-.6-.01-.21 0-.55.08-.84.39-.29.31-1.1 1.08-1.1 2.62 0 1.54 1.13 3.03 1.29 3.24.16.21 2.22 3.4 5.39 4.77.75.32 1.34.51 1.8.66.76.24 1.45.21 2 .12.61-.09 1.84-.75 2.1-1.48.26-.73.26-1.34.18-1.48-.08-.13-.29-.21-.6-.37z"/>
    <path d="M27.32 4.7C24.4 1.78 20.55.17 16.43.17 7.93.17.97 7.13.97 15.63c0 2.72.71 5.36 2.05 7.69L.83 31.83l8.69-2.28c2.24 1.22 4.76 1.86 7.32 1.86h.01c8.5 0 15.46-6.96 15.46-15.46 0-4.13-1.61-7.99-4.99-11.25zM16.43 28.79h-.01c-2.29 0-4.53-.61-6.49-1.77l-.47-.28-4.83 1.27 1.28-4.71-.3-.48a12.94 12.94 0 0 1-1.99-6.89c0-7.13 5.81-12.94 12.94-12.94 3.46 0 6.7 1.35 9.13 3.79 2.44 2.45 3.79 5.69 3.79 9.15-.01 7.13-5.82 12.94-12.95 12.94z"/>
  </svg>
);

const WhatsAppFloat = () => {
  const location = useLocation();
  const { lang } = useLang();

  // Keep private workflows free of unrelated external navigation.
  if (/^\/(admin|payment|schedule|quote)(\/|$)/.test(location.pathname)) return null;

  const PHONE = "15105079318"; // (510) 507-9318 in international format
  const MESSAGES = {
    en: "Hi Xavier! I'd like a quote for outdoor structure installation.",
    pt: "Olá Xavier! Gostaria de um orçamento para instalação de estrutura externa.",
    es: "¡Hola Xavier! Quisiera una cotización para instalación de estructura exterior.",
  };
  const LABELS = {
    en: "Chat on WhatsApp",
    pt: "Conversar no WhatsApp",
    es: "Chatear por WhatsApp",
  };

  const text = MESSAGES[lang] || MESSAGES.en;
  const label = LABELS[lang] || LABELS.en;
  const href = `https://wa.me/${PHONE}?text=${encodeURIComponent(text)}`;

  return (
    <a
      data-testid="whatsapp-float-btn"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      className="fixed z-50 bottom-5 right-5 sm:bottom-6 sm:right-6 group"
      style={/^\/installer(\/|$)/.test(location.pathname)
        ? { bottom: "calc(88px + env(safe-area-inset-bottom, 0px))" }
        : undefined}
    >
      {/* Pulse ring */}
      <span className="absolute inset-0 rounded-full bg-[#25D366]/40 animate-ping pointer-events-none" />
      <span className="relative flex items-center justify-center h-14 w-14 sm:h-16 sm:w-16 rounded-full bg-[#25D366] hover:bg-[#1ebe57] text-white shadow-[0_8px_30px_rgba(37,211,102,0.45)] border border-white/10 transition-all duration-300 hover:scale-105">
        <WhatsAppIcon size={28} />
        {/* Tooltip on desktop hover */}
        <span className="hidden sm:block absolute right-full mr-3 whitespace-nowrap bg-zinc-900 text-white text-xs font-display font-semibold uppercase tracking-[0.15em] px-3 py-2 border border-white/10 opacity-0 group-hover:opacity-100 transition-opacity">
          {label}
        </span>
      </span>
    </a>
  );
};

export default WhatsAppFloat;
